import APP_ACTIONS from '../constants/app-actions';
import TaxonModel from '../services/taxon-model';
import NavigationModel from '../services/navigation-model';
import ProductsAPI from '../apis/products';
import { getParamsFromWindowLocationSearch } from '../helper';
import MunicipalityService from '../services/municipality-service';

const products = {
    addProducts: (productsResponse) => ({
        type: APP_ACTIONS.ADD_PRODUCTS,
        payload: productsResponse,
    }),

    addAllStoreProducts: (productsResponse) => ({
        type: APP_ACTIONS.ADD_PRODUCTS_FROM_ALL_STORES,
        payload: productsResponse,
    }),

    appendProducts: (productsResponse) => ({
        type: APP_ACTIONS.APPEND_PRODUCTS,
        payload: productsResponse,
    }),

    addProduct: (product) => ({
        type: APP_ACTIONS.ADD_PRODUCT,
        payload: product,
    }),

    fetchProducts: (paramsToMerge = {}) => (dispatch, getState) => {
        const currentState = getState();

        const currentPathName = currentState.routing.location.pathname;
        let taxon = TaxonModel.findByPermalink(currentPathName, currentState.taxons.fetchedTaxons);

        const params = getParamsFromWindowLocationSearch();

        if (params.price_min) {
            paramsToMerge.price = params.price_min;
            if (params.price_max) {
                paramsToMerge.price += `,${params.price_max}`;
            }
        }

        paramsToMerge.storeId = params.store_id ? params.store_id : currentState.stores.currentStore.id;

        paramsToMerge.searchTerm = params.query || '';

        if (params.category) {
            const fetchedTaxons = currentState.taxons.taxonsMenu.find((taxons) => taxons.store.id === currentState.stores.currentStore.id);
            if (fetchedTaxons) {
                fetchedTaxons.taxons.find((storeTaxons) => {
                    if (params.category === storeTaxons.taxonCategory.permalink) {
                        taxon = storeTaxons.taxonCategory;
                        return taxon;
                    }
                    taxon = TaxonModel.findByPermalink(params.category, storeTaxons.taxons, '');
                    return taxon;
                });
            }
            paramsToMerge.searchTerm = '';
        }

        if (currentState.zones.currentZone) {
            paramsToMerge.zone = currentState.zones.currentZone;
        }

        if (taxon) {
            paramsToMerge.taxonId = taxon.id;
            paramsToMerge.searchTerm = '';
        }

        const { zones: { availableZones, currentZone }, municipalities: { availableMunicipalities, currentMunicipality } } = currentState;
        const selectedZoneMunicipalities = MunicipalityService.getAvailableMunicipalitiesByZoneId(currentZone, availableZones, availableMunicipalities);
        if (currentMunicipality && !MunicipalityService.isMunicipalitySelectorModalRequired(currentMunicipality, selectedZoneMunicipalities)) {
            paramsToMerge.municipality = currentState.municipalities.currentMunicipality;
        }

        return ProductsAPI.getList(paramsToMerge);
    },

    fetchAllStoreProducts: (paramsToMerge = {}) => (dispatch, getState) => {
        const currentState = getState();

        const params = getParamsFromWindowLocationSearch();

        paramsToMerge.searchTerm = params.query || '';

        if (currentState.zones.currentZone) {
            paramsToMerge.zone = currentState.zones.currentZone;
        }

        if (currentState.municipalities.currentMunicipality) {
            paramsToMerge.municipality = currentState.municipalities.currentMunicipality;
        }

        return ProductsAPI.getAllStoreList(paramsToMerge);
    },
};

export default products;



/** WEBPACK FOOTER **
 ** ./src/actions/products.js
 **/